import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Searchlistprepress from '../searchlistprepress';

function PopupSearch() {
 
  const [fullscreen, setFullscreen] = useState(true);
  const [show, setShow] = useState(false);

  function handleShow(v) {
    setShow(v);
  }

  return (
    <>
    
        <Button  className="me-2 mb-2" onClick={() => handleShow(true)}>
          รายงานเอกสาร
        </Button>
   
      <Modal show={show} fullscreen={fullscreen} onHide={() => handleShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>ค้นหา เอกสาร  </Modal.Title>
        </Modal.Header>
        <Modal.Body>
           <Searchlistprepress />
        </Modal.Body>
      </Modal>
    </>
  );
}

export default PopupSearch;